export const calcDeclineRate = (current: number, previous: number) => {
  if (current === 0 || previous === 0) {
    return 0;
  }
  return (current - previous) / previous * 100;
}

export const shuffle = (array: any[]) =>{
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}

export const countryTextMap = {
  'US': '미국',
  'KR': '한국',
};

export const wrapCloudinary = (uri: string) => {
  if (uri.startsWith("file")) {
    return uri;
  }

  return `https://res.cloudinary.com/simplediaryapp/image/fetch/${encodeURIComponent(
    uri
  )}`;
};
